import React, { useState, useEffect, createRef } from "react";
import { withRouter, Link } from "react-router-dom";

//Utils
import { mapPageNav, mapPageNavMobile } from "../../../Utils/Utils";

//Hero Images
import driveways from "../images/categories/driveways/driveways-banner.jpg";
// import firefeatures from "../images/categories/firefeatures/firefeatures-banner.jpg";
import gardenwalls from "../images/categories/gardenbeds/gardenbeds-banner.jpg";
import patios from "../images/categories/patios/patios-banner.jpg";
import pooldecks from "../images/categories/pooldecks/pooldecks-banner.jpg";
import steps from "../images/categories/steps/steps-banner.jpg";
import walkways from "../images/categories/walkways/walkways-banner.jpg";

const Hero = (props) => {
  const [herobg, setHerobg] = useState(driveways);
  const [heroTitle, setHeroTitle] = useState("Carpentry");

  const { pathname } = props.location;
  const { params } = props.match;

  const sliderRef = createRef();

  useEffect(() => {
    switch (params.category) {
      case "driveways":
        setHerobg(driveways);
        setHeroTitle("Driveways");
        sliderRef.current.innerSlider.slickGoTo(0);
        break;
      // case "firefeatures":
      //   setHerobg(firefeatures);
      //   setHeroTitle("Fire Features");
      //   sliderRef.current.innerSlider.slickGoTo(1);
      //   break;
      case "garden-walls":
        setHerobg(gardenwalls);
        setHeroTitle("Garden Walls");
        sliderRef.current.innerSlider.slickGoTo(1);
        break;
      case "patios":
        setHerobg(patios);
        setHeroTitle("Patios");
        sliderRef.current.innerSlider.slickGoTo(2);
        break;
      case "pool-decks":
        setHerobg(pooldecks);
        setHeroTitle("Pool Decks");
        sliderRef.current.innerSlider.slickGoTo(3);
        break;
      case "steps-and-coping":
        setHerobg(steps);
        setHeroTitle("Steps & Coping");
        sliderRef.current.innerSlider.slickGoTo(4);
        break;
      case "walkways":
        setHerobg(walkways);
        setHeroTitle("Walkways");
        sliderRef.current.innerSlider.slickGoTo(5);
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const links = [
    {
      title: "Driveways",
      destination: `/gallery/driveways`,
    },
    // {
    //   title: "Fire Features",
    //   destination: `/gallery/firefeatures`,
    // },
    {
      title: "Garden Walls",
      destination: `/gallery/garden-walls`,
    },
    {
      title: "Patios",
      destination: `/gallery/patios`,
    },
    {
      title: "Pool Decks",
      destination: `/gallery/pool-decks`,
    },
    {
      title: "Steps & Coping",
      destination: `/gallery/steps-and-coping`,
    },
    {
      title: "Walkways",
      destination: `/gallery/walkways`,
    },
  ];

  return (
    <>
      <div className="row justify-content-center panel-hero">
        <div
          className="col-12 hero-unit no-side-padding"
          style={{ backgroundImage: `url(${herobg})` }}
        >
          <div className="title">
            <Link to="/gallery">Back to Gallery</Link>
            <h1>{heroTitle}</h1>
          </div>
        </div>
      </div>
      <div className="row justify-content-around panel-hero">
        <div className="col-12 mobile-hidden">
          <div className="row page-navigation">
            {mapPageNav(links, pathname)}
          </div>
        </div>
      </div>
      <div className="page-navigation desktop-hidden">
        {mapPageNavMobile(links, pathname, sliderRef, props.history)}
      </div>
    </>
  );
};

export default withRouter(Hero);
